import { useEffect } from 'react';
import { useBrowser } from '../services/BrowserService';

/** Adds a global value to the window to allow tooling and devs to interact with it.
 * Cleans up upon unmount.
 */
export const useExposedToWindow = <K extends keyof Window>(key: K, value: Window[K]) => {
  const { window } = useBrowser();

  useEffect(() => {
    if (window) {
      const originalValue = window[key];
      window[key] = value;

      return () => {
        window[key] = originalValue;
      };
    }

    return undefined;
  }, [window, key, value]);
};
